<template>
<div>
  <v-container style="padding-top: 0px;">
      <v-row justify="center">
        <v-col lg="12">
          <v-card flat class="bcg">
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("destroyToken")
    this.$router.push('/')
  }
};
</script>

<style>
</style>